/**
 @author chunfeng
 @date 2020/05/03 18:56
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;


// 获取中心管控消息
let token01 = null;
export const getTeamSharingNewsList = async (data) => {
    if (token01) {
        token01.cancel({statue: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[1] + '/GetTeamSharingList?',
        method: "get",
        token: token01.token,
    })
}
//修改消息已读状态
let token02 = null;
export const setTeamSharingNewsListRead = async (id) => {
    if (token02) {
        token02.cancel({statue: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[1] + '/SetTeamSharingUnreadRead?' + qs.stringify(id),
        method: "get",
        token: token02.toKen,
    })
}

// 删除故事版共享消息
let token03 = null;
export const deleteTeamSharingNews = async (id) => {
    if (token03) {
        token03.cancel({statue: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[1] + "/RemoveTeamSharing?" + qs.stringify(id),
        method: "get",
        token: token03.toKen,
    })
};


